export default __webpack_public_path__ + "static/media/dos.613f7423.jpg";